import { useRequest } from 'ahooks'
import { toJS } from 'mobx'
import { useEffect } from 'react'

import usePopup from '../../HYBVant/HPopup/hooks/usePopup'

import { personnelDetails } from './service'

export default ({ staff_Id, staffDetail, taxUserInfos, setState, onConfirm }: any) => {
  const { open, modalData, onCancel, onOpen } = usePopup({})
  useEffect(() => {
    detailsOk()
  }, [staff_Id])
  // 人员信息详情查询
  const detailsOk = () => {
    runPersonnelDetails(staff_Id)
  }
  // 人员信息详情
  const { run: runPersonnelDetails } = useRequest(personnelDetails, {
    manual: true,
    onSuccess: (result: any) => {
      const { data, code } = result
      if (code === 2000) {
        setState({
          staffDetail: data || {},
          taxUserInfos: transformedArray(data?.tax_map?.tax_user_info_list || [])
        })
      }
    },
    onError: ({ message }) => {
      console.log('error', message)
      setState({ staffDetail: {} })
    }
  })
  const transformedArray = (list: any[] = []) => {
    return (
      list?.map((item: any, index: any) => ({
        ...item, // 将原始对象的属性展开到新对象中
        key: index
      })) || []
    )
  }
  const add = () => {
    setState({
      isInvestmentRatio: true,
      isaAbnormal: false
    })
    onOpen({
      status: 'Add',
      editItem: {
        position_id: staffDetail?.work_map?.hrm_position_id
          ? String(staffDetail?.work_map?.hrm_position_id)
          : null
      }
    })
  }

  const edit = (index: number) => {
    const record = taxUserInfos?.[index] || {}
    const values_ = {
      ...record,
      status: record?.status ? String(record?.status) : null,
      tax_calculation_method: record?.tax_calculation_method
        ? String(record?.tax_calculation_method)
        : null,
      employment_type: record?.employment_type ? String(record?.employment_type) : null,
      position_id: record?.position_id
        ? String(record?.position_id)
        : staffDetail?.work_map?.hrm_position_id
          ? String(staffDetail?.work_map?.hrm_position_id)
          : null,
      office_id: record?.office_id ? String(record?.office_id) : null
    }
    setState({
      isInvestmentRatio: record?.status === '1',
      isaAbnormal: record?.investment_total === null
    })
    onOpen({ status: 'Edit', editItem: values_ })
  }

  const runSaveTaxUserInfos = async (data: any) => {
    setState({ taxUserInfos: data })
    onCancel()
  }

  const runDeleteTaxUserInfos = (data: any) => {
    setState({ taxUserInfos: data })
    onCancel()
  }

  useEffect(() => {
    if (onConfirm) onConfirm(taxUserInfos)
  }, [taxUserInfos])
  return {
    add,
    edit,
    open,
    modalData,
    onCancel,
    onOpen,
    runDeleteTaxUserInfos,
    runSaveTaxUserInfos,
    deleteTaxUserInfosLoading: false,
    saveTaxUserInfosLoading: false
  }
}
